import {useSelector} from 'react-redux';
import Selector from '../../../../../../selectors/pages/home/facebook_boost';
import ModalsLib from '../../../../../../lib/modals';

export default () => {
    const {isAuth} = useSelector(Selector);

    return (
        <div className="slide methods size-params">
            <div className="size-params-layer layer0"><div className="methods-icon"></div></div>
            <div className="layer-margin size-params slide-details">
                <div className="title">
                    CASH<br/>METHODS
                </div>
                <div className="descriptions-short">Make deposits through any cash deposit method that is convenient for you!</div>
                <div className="details">
                    <div className="button" onClick={e => {
                        if(isAuth)
                            ModalsLib.open('wallet')
                        else
                            ModalsLib.open('signin')
                    }}>Make deposit</div>
                </div>
            </div>
        </div> 
    )
}